import Head from 'next/head';
import { SlideProps } from '@/types/componentTypes';
import Carousel from '@/components/Carousel';
import images from '../../datas/slides.json';

const Page = () => {
  const datas: SlideProps[] = images.datas;
  return (
    <>
      <Head>
        <title>Carousel</title>
      </Head>

      <h1>Carousel</h1>
      <Carousel slides={datas} />
    </>
  );
};

export default Page;
